import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import '../styles/ContactForm.css';
import contactImage from '../assets/contacto.png'; // tu imagen

export default function ContactForm() {
  const [formData, setFormData] = useState({
    name: '',
    surname: '',
    email: '',
    message: ''
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    emailjs.send(
      process.env.REACT_APP_EMAILJS_SERVICE_ID,
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
      {
        name: formData.name,
        surname: formData.surname,
        email: formData.email,
        message: formData.message
      },
      process.env.REACT_APP_EMAILJS_PUBLIC_KEY
    )
    .then(() => {
      setSuccess(true);
      setFormData({
        name: '',
        surname: '',
        email: '',
        message: ''
      });
      setLoading(false);
    })
    .catch((error) => {
      console.error('EmailJS error:', error);
      setLoading(false);
      alert('Error al enviar el mensaje');
    });
  };

  return (
    <section id="contact" className="contact-section">
      <div className="contact-container">

        {/* Imagen izquierda */}
        <div className="contact-image">
          <img src={contactImage} alt="Contacto inmobiliario Serrano" />
        </div>

        {/* Formulario */}
        <div className="contact-content">
          <h2 className="didot-italic">Hablemos de tu próximo paso</h2>
          <p className='pform'>
            ¿Tienes preguntas o quieres iniciar un proyecto? Comparte o consulta  un miembro de nuestro equipo te responderá para cooridnar juntos el siguiente paso.
          </p>

          {success && (
            <span className="success-message">
              Mensaje enviado correctamente ✔
            </span>
          )}

          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Nombre"
              value={formData.name}
              onChange={handleChange}
              required
            />

            <input
              type="text"
              name="surname"
              placeholder="Apellidos"
              value={formData.surname}
              onChange={handleChange}
              required
            />

            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              required
            />

            <textarea
              name="message"
              placeholder="Mensaje"
              value={formData.message}
              onChange={handleChange}
              required
            />

            <button type="submit" disabled={loading}>
              {loading ? 'Enviando...' : 'Enviar'}
            </button>
          </form>
        </div>

      </div>
    </section>
  );
}